import { faSalesforce } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Space, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

const FieldTitle = styled(Text)`
  width: 220px;
  text-align: left;
`;

export const SalesforceFieldValue = ({
  label,
  boldText,
}: {
  label: string;
  boldText?: boolean;
}) => (
  <Space>
    <FontAwesomeIcon icon={faSalesforce} color="var(--icon-primary)" />
    <FieldTitle strong={boldText} ellipsis={{ tooltip: true }}>
      {label}
    </FieldTitle>
  </Space>
);
